// src/theme.ts
import { MantineThemeOverride } from '@mantine/core';

const theme: MantineThemeOverride = {
    // Use a premium dark‑light palette with gradients
    primaryColor: 'blue',
    colors: {
        // Extend the default palette with custom gradient shades if needed
        blue: [
            '#e0f2ff',
            '#b3e0ff',
            '#80cfff',
            '#4dbfff',
            '#1aaeff',
            '#0099e6',
            '#0080b3',
            '#006680',
            '#004d4d',
            '#003333',
        ],
    },
    // Enable glass‑morphism style globally for the custom Card component
    components: {
        Card: {
            defaultProps: {
                variant: 'glass',
                hoverable: true,
            },
        },
    },
    // Global font and spacing to match the premium aesthetic
    fontFamily: 'Inter, system-ui, sans-serif',
    defaultRadius: 'md',
    headings: { fontFamily: 'Inter, system-ui, sans-serif' },
    // Light color scheme – can be toggled later if needed

};

export default theme;
